(function () {
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('is') !== 'product-form') return;
    var btn = form.querySelector('[type="submit"]');
    if (!btn || btn.disabled) return;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    setTimeout(function () {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }, 3500);
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('input[name="quantity"]').forEach(function (el) {
      if (parseInt(el.value) < 1 || el.value === '') el.value = 1;
    });
  });
})();
